import { render, staticRenderFns } from "./News.vue?vue&type=template&id=7e6af5da&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&id=7e6af5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6af5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e6af5da')) {
      api.createRecord('7e6af5da', component.options)
    } else {
      api.reload('7e6af5da', component.options)
    }
    module.hot.accept("./News.vue?vue&type=template&id=7e6af5da&scoped=true&", function () {
      api.rerender('7e6af5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/News.vue"
export default component.exports